import Header from '../components/Header';
import Footer from '../components/Footer';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';

export default function FAQPage() {
  const faqs = [
    {
      question: 'Do I need an app to use SaferPaws?',
      answer: 'No! That\'s the beauty of SaferPaws. Anyone can scan the tag using their smartphone\'s built-in NFC reader or camera (for the QR code). No app download required - it works instantly.'
    },
    {
      question: 'Can any phone scan the tag?',
      answer: 'Yes! Most modern smartphones (iPhone 7 and later, most Android phones from 2015+) support NFC. Even if a phone doesn\'t have NFC, the QR code on the tag works with any camera app.'
    },
    {
      question: 'Is there a monthly subscription fee?',
      answer: 'Absolutely not. SaferPaws is a one-time purchase. Your pet\'s profile stays active forever with no recurring fees or hidden charges.'
    },
    {
      question: 'What happens if my pet goes missing?',
      answer: 'You can activate "Lost Mode" from your dashboard. This changes your pet\'s profile page to show a prominent alert, and enables the "Report Sighting" feature so people can notify you of where they\'ve seen your pet.'
    },
    {
      question: 'Can I update my pet\'s information?',
      answer: 'Yes! You can update your pet\'s photo, contact information, medical notes, and behavior tips anytime through your dashboard. Changes appear instantly on the profile.'
    },
    {
      question: 'Is the tag waterproof?',
      answer: 'Yes! SaferPaws tags are fully waterproof and designed to withstand rain, baths, swimming, and everyday adventures. They\'re built to last.'
    },
    {
      question: 'How does the contact work - do finders get my phone number?',
      answer: 'When someone scans the tag, they see contact buttons (Call, WhatsApp, SMS) that use their own phone to reach you. The messaging uses their phone\'s native apps, so there are no fees or third-party services involved.'
    },
    {
      question: 'Can someone else activate my tag?',
      answer: 'Each tag can only be activated once. Once you create a profile, it\'s linked to that tag. If you need to transfer a tag to a new pet, contact our support team.'
    },
    {
      question: 'What if I have multiple pets?',
      answer: 'Each pet needs their own tag. We offer a Family Pack at a discounted price for multi-pet households. Each tag creates a unique profile.'
    },
    {
      question: 'Is my information secure?',
      answer: 'Yes. We only display the information you choose to share on the public profile. Your email and backup contact remain private unless you choose to display them.'
    },
    {
      question: 'How do I get help if something isn\'t working?',
      answer: 'You can reach our support team anytime through the Contact page. We typically respond within 24 hours and are happy to help with any issues.'
    }
  ];

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="pt-24 pb-20" data-testid="faq-page">
        {/* Hero */}
        <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center">
          <h1 className="text-4xl sm:text-5xl font-heading font-bold text-foreground tracking-tight">
            Frequently Asked Questions
          </h1>
          <p className="mt-4 text-lg text-muted-foreground">
            Everything you need to know about SaferPaws
          </p>
        </section>

        {/* FAQ Accordion */}
        <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="bg-card rounded-2xl border border-border px-6 data-[state=open]:border-primary/40 transition-colors"
                data-testid={`faq-item-${index}`}
              >
                <AccordionTrigger className="text-left font-heading font-medium text-foreground hover:no-underline py-5">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground pb-5 leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </section>

        {/* Still Have Questions */}
        <section className="bg-card/40 border-y border-border py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-2xl font-heading font-bold text-foreground">
              Still have questions?
            </h2>
            <p className="mt-2 text-muted-foreground">
              We&apos;re here to help. Reach out anytime.
            </p>
            <div className="mt-6">
              <Link to="/contact">
                <Button 
                  className="bg-primary hover:bg-primary/90 rounded-full px-8"
                  data-testid="faq-contact-btn"
                >
                  Contact Support
                </Button>
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
